export default {_name:'stepper.step',module:'Card/Pane',view:'Element/Stepper/Step',options:{key:'step',xs:12}}